import { SkinSize } from '../../lib/skin/getSizeSkin/generated/types';
import { VerticalAlignTextPreset } from '../../hooks/useVerticalAlign/types';

import { TextSize } from './types';

export const textStyles: Record<TextSize, VerticalAlignTextPreset> = {
    '2xs': '10-12',
    xs: '12-16',
    s: '14-20',
    mc: '16-20',
    m: '16-24',
    l: '20-28',
    xl: '24-32',
    '2xl': '32-40',
};

export const textSkinSizes: Record<TextSize, SkinSize> = {
    '2xs': '4xs',
    xs: '2xs',
    s: 'xs',
    mc: 's',
    m: 'm',
    l: 'l',
    xl: 'xl',
    '2xl': '2xl',
};
